module.exports = require("babel-core/register");
